import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button';

/** The round, borderless X used in the top-right of the request-to-play modals. */
export default function CloseButton({ onClose }: { onClose: () => void }) {
  return (
    <Button
      variant="secondary"
      size="icon"
      isInline
      onClick={onClose}
      aria-label="Close"
      className="h-8 w-8 rounded-full border-none bg-transparent lg:w-8"
      iconLeft={<CloseIcon className="h-3.5 w-3.5" />}
    />
  );
}
